import { delay } from 'redux-saga'
import {
  call,
  actionChannel,
  take,
  cancel,
  cancelled,
  select,
  put,
  fork,
  all,
} from 'redux-saga/effects'
import * as R from 'ramda'
import T from 'i18n-react'

import {
  notificationStart,
  notificationEnd,
  updateTimeout,
  updateType,
  updateMessage,
  updateActive,
  clearType,
  clearMessage,
  clearActive,
} from './actions'

import { timeoutSelector } from './selectors'
import {
  MODULE_NAME,
  NOTIFICATION,
  NOTIFICATION_END,
  DEFAULT_ERROR_CODE
} from './constants'

import {
  isNotificationType,
  getPriority,
  buffer
} from './PriorityBuffer'

function* clear() {
  yield put(clearMessage())
  yield put(clearType())
}

function* handleNotification(message, type) {
  try {
    yield put(notificationStart())
    yield put(updateType(type))
    yield put(updateMessage(message))
    yield put(updateActive(true))
    const timeout = yield select(timeoutSelector)
    yield call(delay, timeout)
    yield put(notificationEnd())
  } finally {
    yield put(clearActive())
  }
}

function* watchNotification() {
  const channel = yield actionChannel(isNotificationType, buffer(1))
  let task, priority = 0

  const shouldNotify = (notification) => (
    notification.priority > priority ||
    notification === NOTIFICATION.INFO &&
    notification.priority === priority
  )

  const isNotError = R.either(
    R.equals(NOTIFICATION.INFO),
    R.equals(NOTIFICATION.SUCCESS)
  )

  const getErrorMessage = R.converge(
    (code, newline, detail) => code + newline + detail,
    [
      R.curry(({ code }) => T.translate(
        `error.code.${code}`,
        { notFound: 'Unknown Error.' }
      )),
      R.always('\n '),
      R.prop('detail')
    ]
  )

  //only process request if higher priority and set the priority
  //otherwise we can keep dropping actions
  while(true) {
    const action = yield take(channel)
    const notification = getPriority(action)
    if (notification === NOTIFICATION.FINISHED) {
      priority = 0
    } else if (shouldNotify(notification)) {
      if (task) yield cancel(task)

      if (isNotError(notification)) {
        task = yield fork(handleNotification, action.message, notification.value)
      } else if(NOTIFICATION.ERROR === notification) {
        let errorMessage = getErrorMessage(action.error)
        task = yield fork(handleNotification, errorMessage, notification.value)
      }
      yield call(delay, 1000)
    }
  }
}

function* infoGenerator() {
  while(true) {
    yield put({
      [MODULE_NAME]: NOTIFICATION.INFO,
      type: 'TESTING INFO NOTIFICATION',
      message: 'THIS IS INFO',
    })
    yield call(delay, 3000)
  }
}

function* successGenerator() {
  while(true) {
    yield put({
      [MODULE_NAME]: NOTIFICATION.SUCCESS,
      type: 'TESTING SUCCESS NOTIFICATION',
      message: 'THIS IS SUCCESS',
    })
    yield call(delay, 4000)
  }
}

function* errorGenerator() {
  while(true) {
    yield put({
      [MODULE_NAME]: NOTIFICATION.ERROR,
      type: 'TESTING ERROR NOTIFICATION',
      message: 'THIS IS ERROR',
    })
    yield call(delay, 5000)
  }
}

function* loadSagas() {
  yield all([
    fork(watchNotification),
    /*
    fork(infoGenerator),
    fork(successGenerator),
    fork(errorGenerator),
    */
  ])
}

export default loadSagas
